module.exports = __webpack_public_path__ + "img/web_1_2x.78802a3f.png";